/**
 * Garde contre GHSA-rvm3-566m-v7fv (Capacitor, Critique 9.3, publiée le 31/08/2026).
 * https://github.com/ionic-team/capacitor/security/advisories/GHSA-rvm3-566m-v7fv
 * (consultée le 01/10/2026).
 *
 * Dans les binaires Capacitor 8.0.0 → 8.4.2 et 8.5.0, un lien vers le chemin
 * interne `/_capacitor_http_interceptor_` (ou `_https_`) de l'origine de l'app,
 * une fois activé DANS la WebView, fait charger une URL arbitraire « at the
 * application's own origin » — avec l'accès au stockage, aux cookies et aux
 * plugins natifs. Le chemin d'attaque cité par l'avis : « chat messages,
 * comments » — la messagerie Gively transforme en liens les URL écrites par
 * l'autre utilisateur.
 *
 * Le vrai correctif est NATIF (Capacitor ≥ 8.4.3, nouvel AAB/IPA). Cette garde
 * est le contournement documenté par l'avis (« sanitizing user-controlled link
 * targets before WebView rendering »), livré par OTA pour protéger dès
 * maintenant les binaires déjà installés, et conservé ensuite en défense en
 * profondeur. `_capacitor_file_` / `_capacitor_content_` (fichiers locaux
 * légitimes) ne sont PAS concernés.
 */
export const PROXY_INTERNE_CAPACITOR = /\/_capacitor_https?_interceptor_/i;

export function lienVersProxyInterne(href) {
  if (!href) return false;
  let brut = String(href);
  try { brut = decodeURIComponent(brut); } catch (_) { /* garde la forme brute */ }
  return PROXY_INTERNE_CAPACITOR.test(brut);
}

let _installee = false;

export function installerGardeProxyCapacitor(win = typeof window !== "undefined" ? window : null) {
  if (!win || _installee) return;
  _installee = true;
  const doc = win.document;
  const bloquer = (ev) => {
    try {
      const cible = ev.target && ev.target.closest ? ev.target.closest("a[href]") : null;
      if (cible && lienVersProxyInterne(cible.getAttribute("href") || cible.href)) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    } catch (_) { /* une garde ne casse jamais la page */ }
  };
  // Phase de CAPTURE : passe avant tout gestionnaire de l'app.
  doc.addEventListener("click", bloquer, true);
  doc.addEventListener("auxclick", bloquer, true);
  const ouvrir = win.open;
  if (typeof ouvrir === "function") {
    win.open = function ouvrirSansProxy(url, ...reste) {
      if (lienVersProxyInterne(url)) return null;
      return ouvrir.call(win, url, ...reste);
    };
  }
}

export default installerGardeProxyCapacitor;
